<template>
    <div :class="styles.wrapper" style="max-width: 100%;" class="d-flex align-center">
        <span :class="adjustedClass"
            @focusout="onEditableChange('heading')"
            :contenteditable="editableContent"
            v-html="layout == 'PPJB'? item.text.replace(/font-size: [^;]+;/g, '') : item.text"
            @paste="layoutsToDisablePasteFilter.includes(layout) ? '' : filterPastedContent"
            :id="`${indexes.element}-${indexes.column}-${indexes.data}`"
        ></span>
        <div v-if="pageType == 'Canvas'" class="guide ml-5" @click="toggleGuide">?</div>
        <div v-else-if="pageType == 'Preview' && ['editor', 'teacher'].includes(user.userType)"
            :class="styles.guideWrapper"
            style="height: 100%"
        >
            <v-tooltip bottom
                color="rgba(223, 239, 255, 1)"
                max-width="300"
            >
                <template v-slot:activator="{ on, attrs }">
                    <div class="guide" :class="styles.guideClass" v-bind="attrs" v-on="on">?</div>
                </template>
                <div v-html="item.guide" class="pa-3" style="color: #343535 !important; font-size: 16px;"></div>
            </v-tooltip>
        </div>
        <div :class="styles.after"></div>
    </div>
</template>

<script>
import { bus } from "@/main"
import { mapState } from "vuex"
export default {
    data () {
        return {
            GIPBHeaders: ["Dialogue", "Getting Started", "Reading", "Comprehension Questions", "Pattern Practice 1", "Vocabulary", "Translation", "Answer Key"],
            PRHeading: ["Enhance!", "Fill in the blanks using the words above."],
            layoutsToDisablePasteFilter: ["FTDescription"]
        }
    },
    props: ["item", "indexes", "styles", "gridHeadingColor"],
    computed: {
        adjustedClass () {
            if (this.layout == "IE" && (this.item.text.includes(">A</b>") || this.item.text.includes(">B</b>"))) {
                return this.$vuetify.breakpoint.mdAndUp ? [this.styles.classLarge, "ie-heading-border"] : [this.styles.classMobile, "ie-heading-border"]
            }
            else if (this.layout == "GIPB" && this.GIPBHeaders.includes(this.item.text)) {
                return this.$vuetify.breakpoint.mdAndUp ? `${this.styles.classLarge} gipb` : `${this.styles.classMobile} gipb`
            }
            else if (this.layout == "PRT1") {
                let isHeading = false
                for (let i = 0; i < this.PRHeading.length; i++) {
                    isHeading = !!this.item.text.includes(this.PRHeading[i])
                    if (isHeading) break
                }
                return isHeading ? `${this.styles.classLarge} py-0 mt-10` : `${this.styles.classMobile} py-0`
            }

            return this.$vuetify.breakpoint.mdAndUp ? this.styles.classLarge : this.styles.classMobile
        },
        guideClass () {
            return this.layout == "BESD2" ? "mt-5" : ""
        },
        ...mapState("units", ["layout"]),
        ...mapState("user", ["user"])
    },
    methods: {
        onEditableChange (type, lineIndex) {
            const newIndexes = this.indexes
            newIndexes.line = lineIndex
            this.columnEditableData("heading", newIndexes, type)
        },
        toggleGuide () {
            bus.$emit("headingGuide", this.indexes)
        }
    }
}
</script>

<style scoped>
.guide {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    font-size: 18px;
    color: #fff;
    text-align: center;
    line-height: 20px;
    font-weight: bold;
    background: rgb(50, 145, 235);
}
.v-tooltip__content {
    opacity: 1 !important;
    box-shadow: 2px 2px 5px rgba(75, 75, 75, 0.5);
}

.guide:hover {
    cursor: pointer;
}
.cja-heading1 {
    color: #584143;
}
.cja-heading2 {
    color: #d16e79;
}
.cjb-heading1 {
    color: #319fd0;
}
.cjb-heading2 {
    color: #4e5677;
}
.cji-heading1 {
    color: #f9ba04;
}
.cji-heading2 {
    color: #4e5677;
}

.cc-heading1 {
    border: 3px solid #365ca3;
    border-radius: 20px;
    box-shadow: 15px 15px 0px 0px #365ca3;
    width: max-content;
    padding: 0.5rem;
    color: #365ca3;
}
.cc-heading2 {
    border: 3px solid #a53a34;
    border-radius: 10px !important;
    box-shadow: 10px 10px 0px 0px #a53a34;
    width: max-content;
    padding: 0.5rem;
    color: #a53a34;
}
.ph1-heading {
    color: #f04d70;
}
.ph2-heading {
    color: #569fd2;
}
.ph3-heading {
    color: #f46747;
}

.ph4-heading {
    color: #1faefb;
}
.ph5-heading {
    color: #83b245;
}
.ph6-heading {
    color: #f36a6c;
}

.ppbasic-heading1 {
    color: #ed5e87
}

.ppbasic-heading2 {
    color: #f9b223
}

.ppint-heading1 {
    color: #ef476f
}

.ppint-heading2 {
    color: #06d6a0
}

.ppadvance-heading1 {
    color: #fbca74
}

.ppadvance-heading2 {
    color: #d75655
}

.debate-header1 {
    background: linear-gradient(to right top, #f40752, #f9ab8f);
    border-radius: 50px !important;
}

.debate-header2 {
    background: linear-gradient(to right top, #30c67c, #82f4b1);
    border-radius: 50px !important;
}

.responsive-heading {
    font-size: 1.3em;
}

.fsic-header1{
    color: #3d4ed0
}

.milestone-heading1 {
 font-weight: 500
}
.fsic-header1{
    color: #3d4ed0
}

.beda-heading1 {
    color: #8174e5;
}

.beda-heading2 {
    color: #663e7a;
}

.hd1 {
    color: #c4c4c4;
}

.hd1-subdivider {
    background-color: #0086f5;
    width: 7%;
    height: 5px;
    border-radius: 5px;
    display: block !important;
    position: absolute;
    margin-top: 55px;
}

.emailing-highlighted-string {
  background: linear-gradient(to bottom, #ffffff 50%, #fee141 50%);
  text-align: center;
}
.emailing-highlighted-string-white {
  background: linear-gradient(to top, #ffffff 50%, #fee141 50%);
}
.meeting-highlighted-string {
  background: linear-gradient(to bottom, #ffffff 50%, #41feaf 50%);
}
.meeting-highlighted-string-white {
  background: linear-gradient(to top, #ffffff 50%, #41feaf 50%);
}
.bpn-highlighted-string {
  background: linear-gradient(to bottom, #ffffff 50%, #40d0fe 50%);
}
.bpn-highlighted-string-white {
  background: linear-gradient(to top, #ffffff 50%, #40d0fe 50%);
}
.bpp-highlighted-string {
  background: linear-gradient(to bottom, #ffffff 50%, #ff9f1c 50%);
}
.bpp-highlighted-string-white {
  background: linear-gradient(to top, #ffffff 50%, #ff9f1c 50%);
}

.ie-heading-border{
    -moz-border-radius: 30px;
    border-radius: 30px;
    border: 2px solid black;
    height: 60px;
    width: 60px;
    text-align:center;
    background-color: #00000000;
    color: black;
    text-align: center;
}

.besd-heading {
    border-bottom: 1px solid #000000 !important;
}

.gipb {
    color:black !important
}
</style>
